import React from 'react'
import Container from '../../components/Template/container'
import NewsOne from '../../components/Clinic/News/NewsOne'

class NewsView extends React.Component {
  render() {
    return <Container
      className="news"
      currentItem="clinic/news"
      sidebar={<div className="sidebar-default" />}
    >
      <NewsOne />
    </Container>
  }
}

export default NewsView